import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdf6d8ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scanner-title" }
const _hoisted_2 = { class: "scanner-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "camera-loading-image" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "camera-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_qr_stream = _resolveComponent("qr-stream")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_qr_stream, {
        onInit: _ctx.onInit,
        onDecode: _ctx.onDecode,
        class: "camera__container"
      }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_LoadingSpinner),
                _hoisted_3
              ], 64))
            : (!!_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onInit", "onDecode"])
    ])
  ], 64))
}